import { render, staticRenderFns } from "./unPushCustomerList.vue?vue&type=template&id=bb5399f0"
import script from "./unPushCustomerList.vue?vue&type=script&lang=js"
export * from "./unPushCustomerList.vue?vue&type=script&lang=js"
import style0 from "./unPushCustomerList.vue?vue&type=style&index=0&id=bb5399f0&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports